/**
 * 全局数据
 * 使用方式参考 store.getIsApp() | store.setIsApp(true)
 */
import { reactive, readonly } from 'vue'
class kl_store {
    private site: any = null
    private user_info: any = null
    private token: string = common.getStorage('access_token') ? common.getStorage('access_token') : ''
    private kong_access_token: string = common.getStorage('kong_access_token') ? common.getStorage('kong_access_token') : ''
    private refresh_token: string = ''
    private symbol: string = 'KSh' // 货币
    private is_app: boolean = navigator.userAgent.indexOf("kilimall,android") > -1 // 是否在Kilimall安卓APP内
    private no_webp: boolean = document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') < 0 // 不支持webp图片
    private details: any = common.getStorage('details') ? common.getStorage('details') : {}  //详情信息
    private cart: any = null
    private home_datas: any = null  // 首页数据
    private home_scroll_top: number = 0 // 首页滚动条位置
    private home_recommend_datas: any = null // 首页推荐数据
    private wish_list: any = [] //浏览记录
    private store_interface: any = common.getStorage('store_interface') ? common.getStorage('store_interface') : {}  //店铺信息
    private go_back: any = common.getStorage('go_back') ? common.getStorage('go_back') : '/usercenter'
    private category: any = null //搜索子集对比
    private search_id: any = null //搜索保存id
    private gc_id: number = 0
    private after_goods: any = null // 售后商品信息
    private is_bat_only: boolean = false // 售后单申请是否批量处理
    private after_way: any = null // 售后发货方式
    private after_type: any = null // 售后类型
    private after_operator_id: any = null // 查询售后详情，及操作售后单id
    private keepAliveList: any = []
    private isExLink: Boolean = false // 是否是外部链接跳转  目前设置为如果url中携带token则表示是从外部链接跳转过来


    setHomeRecommentDatas(datas: any): void {
        this.home_recommend_datas = datas
    }
    setHomeScrollTop(datas: any): void {
        this.home_scroll_top = datas
    }
    setHomeDatas(datas: any): void {
        this.home_datas = datas
    }
    setSite(datas: any): void {
        this.site = datas
        common.setStorage('site', datas, 15)
    }
    setUserInfo(datas: any): void {
        this.user_info = datas
        common.setStorage('user_info', datas, 15)
    }
    setToken(datas: string, date?: number): void {
        this.token = datas
        common.setStorage('access_token', datas, date ? date : 15)
    }
    setKongToken(datas: string, date?: number): void {
        this.kong_access_token = datas
        common.setStorage('kong_access_token', datas, date ? date : 15)
    }
    setRefreshToken(datas: string, date?: number): void {
        this.refresh_token = datas
        common.setStorage('refresh_token', datas, date ? date * 2 : 30)
    }
    setSymbol(datas: string): void {
        this.symbol = datas
    }
    setIsApp(datas: boolean): void {
        this.is_app = datas
    }
    setNoWebp(datas: boolean): void {
        this.no_webp = datas
    }
    setDetails(datas: Object): void {
        this.details = datas
        common.setStorage('details', datas)
    }
    setCart(data: any) {
        this.cart = data
    }
    setStoreInterface(datas: any) {
        common.setStorage('store_interface', datas)
        this.store_interface = datas
    }
    setWishList(datas: Object): void {
        this.wish_list = datas
    }
    setGoBack(datas: Object): void {
        common.setStorage('go_back', datas)
        this.go_back = datas
    }
    setCategory(datas: Object): void {
        this.category = datas
    }
    setSearchId(datas: Object): void {
        this.search_id = datas
    }
    setGcId(datas: number): void {
        this.gc_id = datas
    }
    setAfterSaleGoods(datas: any): void {
        this.after_goods = datas
    }
    setAfterBat(datas: boolean): void {
        this.is_bat_only = datas
    }
    setAfterWay(datas: any): void {
        this.after_way = datas
    }
    setAfterType(datas: any): void {
        this.after_type = datas
    }
    setAfterId(datas: any): void {
        this.after_operator_id = datas
    }
    setKeepAliveList(datas: any): void {
        this.keepAliveList = datas
    }
    setIsExLink(datas: boolean): void {
        common.setStorage('isExLink', datas)
        this.isExLink = datas
    }

    getHomeRecommentDatas(): any {
        return this.home_recommend_datas
    }
    getHomeScrollTop(): any {
        return this.home_scroll_top
    }
    getHomeDatas(): any {
        return this.home_datas
    }
    getSite(): any {
        return this.site
    }
    getUserInfo(): object {
        return this.user_info
    }
    getToken(): string {
        return this.token
    }
    getKongToken(): string {
        return this.kong_access_token
    }
    getSymbol(): string {
        return this.site ? this.site.symbol : 'KSh'
    }
    getIsApp(): boolean {
        return this.is_app
    }
    getNoWebp(): boolean {
        return this.no_webp
    }
    getDetails(): object {
        return this.details
    }
    getCart(): any {
        return this.cart
    }
    getStoreInterface(data: any) {
        return this.store_interface
    }
    getWishList(): Array<Object> {
        return this.wish_list
    }
    getGoBack(datas: Object): void {
        return this.go_back
    }
    getCategory(datas: Object): void {
        return this.category
    }
    getSearchId(): void {
        return this.search_id
    }
    getGcId(datas: number): number {
        return this.gc_id
    }
    getAfterSaleGoods(): any {
        return this.after_goods
    }
    getAfterBat(): boolean {
        return this.is_bat_only
    }
    getAfterWay():any {
        return this.after_way
    }
    getAfterType(): any {
        return this.after_type
    }
    getAfterId(): any {
        return this.after_operator_id
    }
    getKeepAliveList(): any {
        return this.keepAliveList
    }
    getIsExLink(): any {
        return this.isExLink
    }

    deleteHistoryList(datas: Object): void {
        this.wish_list = datas
    }

    constructor() {
        // 取出缓存写入到属性
        console.log('初始化全局函数', window.common)
        if (common.getStorage('site')) {
            this.setSite(common.getStorage('site'))
        }
    }

}

export {
    kl_store,
}